import React from 'react';
import type { SecurityAlertRow } from '../../../models/securityDashboard';
import { formatUtcDateTime } from '../../../shared/utils/formatDate';

export interface SecurityAlertsPanelProps {
  alerts: SecurityAlertRow[];
}

export function SecurityAlertsPanel({ alerts }: SecurityAlertsPanelProps): React.ReactElement {
  return (
    <div className="bo-card">
      <div className="bo-admin-table-wrap">
        <table className="bo-admin-table">
          <thead>
            <tr>
              <th>Detected</th>
              <th>Type</th>
              <th>Severity</th>
              <th>Company</th>
              <th>User</th>
              <th>Correlation</th>
            </tr>
          </thead>
          <tbody>
            {alerts.map((alert) => (
              <tr key={alert.id}>
                <td>{formatUtcDateTime(alert.detectedAt)}</td>
                <td>{alert.alertType}</td>
                <td>{alert.severity}</td>
                <td>{alert.companyId ?? '—'}</td>
                <td>{alert.userId ?? '—'}</td>
                <td>{alert.correlationId ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
